import { render, staticRenderFns } from "./OrderRecap.vue?vue&type=template&id=74fd4700"
import script from "./OrderRecap.vue?vue&type=script&lang=ts"
export * from "./OrderRecap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports